import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  DialogService,
  NotificationService,
  UserAuth,
  DmzSystemSettingService,
  CommonRegEx
} from '@nrwl/common-lib';

@Component({
  selector: 'public-web-access',
  templateUrl: './public-web-access.component.html',
  styleUrls: ['./public-web-access.component.scss']
})
export class publicWebAccessComponent implements OnInit, OnDestroy {
  @ViewChild('webAccess', { static: true }) form: NgForm;
  hostNameRegEx = CommonRegEx.HOST_NAME;
  ipRegEx = CommonRegEx.IP_REGEX;
  hostNameAndIPRegEx = new RegExp(this.ipRegEx.source + '|' + this.hostNameRegEx.source);
  isValidHostnameOrIPaddress = true;
  isLoading: boolean;
  loaderMessage = 'Getting DMZ Server Config...';
  title = 'DMZ Server';
  formData = {
    hostName: '0.0.0.0',
    port: '80'
  };
  isUserManageSystem: string;
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private readonly notificationService: NotificationService,
    private readonly dmzSystemSettingService: DmzSystemSettingService,
    private readonly dialogService: DialogService,
    private readonly userAuth: UserAuth
  ) {
    this.isUserManageSystem = this.userAuth.isAuthedFor('MANAGE_SYSTEM');
  }

  ngOnInit() {
    //eslint-disable-next-line
    this.getServerConfig();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  getServerConfig(): void {
    this.isLoading = true;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.dmzSystemSettingService
      .getWebServerConfig()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.formData.hostName = res.data['vibe-public-access'].hostname;
          this.formData.port = res.data['vibe-public-access'].port;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          const successMsg = 'There is problem while fetching server config';
          this.notificationService.onFail(successMsg);
        }
      );
  }
  //eslint-disable-next-line
  callBackSaveAck(service): void {
    service.callBackDmzServerConfigSave();
  }
  //eslint-disable-next-line
  callBackDmzServerConfigSave(): any {
    this.loaderMessage = 'Saving DMZ Server Config...';
    const publicAccess = {
      config: {
        'vibe-public-access': {
          hostname: this.formData.hostName,
          port: this.formData.port
        }
      },
      restartRequired: false
    };
    this.isLoading = true;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.dmzSystemSettingService
      .updateDmzWebConfig(publicAccess)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.formData.hostName = res.data['vibe-public-access'].hostname;
          this.formData.port = res.data['vibe-public-access'].port;
          this.isLoading = false;
          const successMsg = 'Public web access server has been updated';
          this.notificationService.onSuccess(successMsg);
        },
        err => {
          this.isLoading = false;
          const successMsg = 'There was an issue updating public web access:' + err.message;
          this.notificationService.onFail(successMsg);
        }
      );
  }

  onChangeHostnameOrIPaddress(): void {
    this.formData.hostName.match(this.hostNameAndIPRegEx)
      ? (this.isValidHostnameOrIPaddress = true)
      : (this.isValidHostnameOrIPaddress = false);
  }

  //eslint-disable-next-line
  saveConfig(): any {
    if (this.isValidHostnameOrIPaddress) {
      const param = {
        id: 'datasource.dmzServerConfig',
        alternateMsg: `You are attempting to make changes to how the UI will communicate with the back end services. </br> Note: This will not change the configuration of back end services. To reconfigure the back end services, see the Administration guide.</br> Do you want to continue?`,
        callBackService: this,
        callBackFuntion: this.callBackSaveAck
      };
      this.dialogService.showDialog('confirm', 'body', param);
    }
  }
}
